export default __webpack_public_path__ + "static/media/White_Cloud_large_4.4d57886e.jpg";